import type { AdFormat } from '../constants';
import { GOOGLE_AD_CLIENT_ID, type GoogleAdLocale, googleLocaleMapping } from './constants';

// TODO: To remove once all google ads are removed
export function getGoogleAdUnit(locale: GoogleAdLocale, adFormat: AdFormat) {
	return `/${GOOGLE_AD_CLIENT_ID}/${googleLocaleMapping[locale]}_${adFormat}_hp`;
}

export function setupGoogleAds() {
	// Ensure we can interact with the Google Publisher Tag command array.
	window.googletag = window.googletag || { cmd: [] };

	window.googletag.cmd.push(() => {
		// Documentation about why these values are set can be found here:
		// https://prebidaio.reworldmediafactory.com/doc-site-evol/fr/viamichelin.com/%2F46980923%252C2787961%2Fviamichelin.com?habillage=0&oneView=1&cmp=didomi&prebidUtils=1&safeFrame=1
		//
		// Documentation about the actual values can be found here:
		// https://developers.google.com/publisher-tag/reference#googletag.SafeFrameConfig
		const safeFramePageConfig = {
			allowOverlayExpansion: false,
			allowPushExpansion: false,
			sandbox: true,
		};

		googletag.pubads().setSafeFrameConfig(safeFramePageConfig);

		// Enable SRA and services.
		googletag.pubads().disableInitialLoad();
		googletag.pubads().enableSingleRequest();
		googletag.pubads().setForceSafeFrame(true);

		// Enable collapse mode otherwise reworld ads will not work
		// Even though this is not necessarily needed since we have our own
		// collapsible component system available
		googletag.pubads().collapseEmptyDivs();
		googletag.enableServices();
	});
}
